import { authenticationLocalStorage } from "@/utils/constants/localStorage";
import axios, { AxiosInstance } from "axios";

export const BASE_URL = `${process.env.REACT_APP_BACKEND_PROTOCOL}://${process.env.REACT_APP_BACKEND_HOST}:${process.env.REACT_APP_BACKEND_PORT}`;

const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to add token to requests
api.interceptors.request.use(
  (config) => {
    const { token } = authenticationLocalStorage;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add interceptor to handle 403 responses
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 403 && !globalThis.location.href.includes("/login")) {
      // Perform logout action here
      authenticationLocalStorage.clear();
      globalThis.location.href = "/login?reason=access_denied";
    }
    return Promise.reject(error);
  }
);

// Service made to centralize api calls
const ApiService = {
  async get<T>(endpoint: string, params?: Record<string, unknown>): Promise<T> {
    return new Promise((resolve, reject) =>
      api
        .get(endpoint, { params })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  },

  async post<T>(endpoint: string, data?: unknown): Promise<T> {
    return new Promise((resolve, reject) =>
      api
        .post(endpoint, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  },

  async put<T>(endpoint: string, data?: unknown): Promise<T> {
    return new Promise((resolve, reject) =>
      api
        .put(endpoint, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  },

  async delete(endpoint: string): Promise<void> {
    return new Promise((resolve, reject) =>
      api
        .delete(endpoint)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  },
};

export default ApiService;
